import React,{useState} from "react";
import {Link} from "react-router-dom"
import {Modal } from "react-bootstrap";
import {
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterIcon,
  FacebookIcon,
  TelegramIcon,
} from "react-share";


export default function BusinessBlock({
  img,
  title,
  rating,
  ratingNumber,
  details,
  city,
  category,
  increaseCounter,
  to,
  refID
}) {
  const [open,setOpen] = useState(false)
  const handleShare =()=>{
    if(navigator.share){
      navigator.share({
        title:title,
        url:to
      }).then(()=>console.log("Thank you for sharing"))
    }
    else{
      setOpen(true)
    }
  }
  return (
    <div onClick={increaseCounter}>
      <div className="content">
        <div className="position-relative">
          <img
            src={img}
            width="100%"
            className="list-img"
            style={{ height: 200 }}
            alt={title}
          />
          <div className="position-absolute d-flex justify-content-between save_preview align-items-center">
            <div className="d-flex justify-content-between align-items-center">
              <i className="fa fa-home"></i>
              <span className="ml-1">Hub</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <i className="fa fa-share-alt"></i>
              <span onClick={handleShare} className="ml-1 cursor">Share</span>
            </div>
          </div>
        </div>
        <div className="offering_content py-3">
          <h3>{title}</h3>
          <div className="d-flex align-items-center fs-14">
            <div>
              <span className="rating">{rating}</span>
              <span>{ratingNumber} Rating</span>
            </div>
            <span className="mx-2"> | </span>
            <div className="d-flex align-items-center">
              <i className="fa fa-home"></i>
              <span className="ml-1">{category}</span>
            </div>
          </div>
          <p className="my-3">
            <i className="fa fa-map-marker mr-1" aria-hidden="true"></i>
            {details}
          </p>
        </div>
        <div className="d-flex justify-content-between align-items-center city">
          <span>{city}</span>
          <Link to={to}><span className="opened">Details</span></Link>
        </div>
      </div>
      <Modal
          show={open}
          onHide={() => setOpen(false)}
          keyboard={false}
        >
          <Modal.Header closeButton>
          <Modal.Title className="text-red">Share {title} <img
             src={img}
              height="64px"
              width="64px"
              style={{ borderRadius: "50%" }}
              alt={title}
            /></Modal.Title>
          </Modal.Header>
          <Modal.Body className="d-flex justify-content-center align-items-center">
           <div className="text-center">
           <div className="d-flex justify-content-between">
           
            <div>
            <FacebookShareButton className="mr-2" url={`https://www.hubsquares.com/listing-details/${refID}`}>
                <FacebookIcon size={32} round={true} />
            </FacebookShareButton>
            <WhatsappShareButton className="mr-2" url={`https://www.hubsquares.com/listing-details/${refID}`}>
                <WhatsappIcon size={32} round={true} />
              </WhatsappShareButton>
            <TwitterShareButton className="mr-2" url={`https://www.hubsquares.com/listing-details/${refID}`}>
                <TwitterIcon size={32} round={true} />
              </TwitterShareButton>
              <TelegramShareButton className="mr-2" url={`https://www.hubsquares.com/listing-details/${refID}`}>
                <TelegramIcon size={32} round={true} />
              </TelegramShareButton>
              </div>
           </div>
           </div>
          </Modal.Body>
        </Modal>
    </div>
  );
}
